import { useEffect, useState } from 'react';

import { BACKEND_FILTER_VALUES } from '@config/filterOperators';
import { routes } from '@navigation/Constants';
import { getByPathAndParams } from '@services/BaseApi';

const useHomePageData = () => {
  const [homePageData, setHomePageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getHomePageData = async () => {
    try {
      const { data } = await getByPathAndParams({
        path: routes.path.publicProperties,
        params: {
          filters: {
            advancedFilters: [
              {
                key: 'type',
                value: 'HOME_PAGE',
                operation: BACKEND_FILTER_VALUES.equals
              }
            ]
          }
        },
        temApi: true
      });

      setHomePageData(data || []);
    } catch (error) {
      console.error('HOME PAGE ERROR:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHomePageData();
  }, []);

  return { homePageData, isLoading };
};

export default useHomePageData;
